// extracted by mini-css-extract-plugin
module.exports = {"signup":"signUp_signup__1zfH7","login":"signUp_login__2hn7X"};